module.exports = __webpack_public_path__ + "img/logo-test.852d4c95.png";